<template>
  <div class="member-hompage">
    <!-- TODO: 首页  -->
    <no-ssr placeholder="Loading...">
      <div class="carousel-box" v-if="picList.length">
        <Carousel :picList="picList"></Carousel>
      </div>
    </no-ssr>
    <div class="member-equity">
      <h2 class="vip-title">会员体系</h2>
      <div class="info-box">
        <memberInfoBar
          v-for="item in vipList"
          :key="item.goodsId"
          :equity="vipEquity"
          :memberType="{
            type:item.vipType,
            name:item.vipName,
            price:item.prices[0].currentPrice,
            goodsId:item.goodsId
          }"
        ></memberInfoBar>
      </div>
    </div>
    <div class="normal-problem">
      <h2 class="vip-title">常见问题</h2>
      <vipNormalProblem />
    </div>
  </div>
</template>

<script>
import memberInfoBar from '~/components/member/member-info-bar';
import Carousel from '~/components/member/carousel';
import vipNormalProblem from '~/components/member/vip-normal-problem';
import * as api from '~/api/index';

export default {
  layout: 'wite_default',
  components: {
    Carousel,
    memberInfoBar,
    vipNormalProblem
  },
  async asyncData({ params, route, error, app, req, $axios }) {
    let [vipListRes, vipEquityRes, vipBanner] = await Promise.all([
      $axios(api.vipList()),
      $axios(api.vipEquity()),
      $axios(api.getBanner({ type: 'vip' }))
    ]);
    return {
      vipList: vipListRes.result,
      vipEquity: vipEquityRes.result,
      vipBanner: vipBanner.result
    };
  },
  data() {
    return {};
  },
  computed: {
    picList() {
      return this.vipBanner
        ? this.vipBanner.map(e => {
            return {
              url: e.coverImageUrl,
              link: e.link,
              title: '',
              type: ''
            };
          })
        : [];
    }
  }
};
</script>

<style lang="less" scoped>
.member-hompage {
  background-color: #fff;
  padding-top: 20px;
  .vip-title {
    position: relative;
    font-size: 24px;
    font-weight: 600;
    color: rgba(51, 51, 51, 1);
    line-height: 36px;
    text-align: center;
    margin-bottom: 40px;
    &::after {
      content: '';
      display: block;
      position: absolute;
      bottom: -10px;
      left: 50%;
      transform: translateX(-50%);
      width: 48px;
      height: 4px;
      background: rgba(207, 169, 114, 1);
    }
  }
  .carousel-box {
    margin: 0 auto;
    width: 1200px;
    margin-bottom: 100px;
  }
  .member-equity {
    margin-top: 50px;
    width: 100%;
    padding-bottom: 100px;
    background: linear-gradient(to top, #f6f6f6 80%, #fff 66%);
    .info-box {
      width: 1200px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
    }
  }
  .normal-problem {
    padding-bottom: 148px;
    padding-top: 87px;
    .vip-title {
    }
  }
}
</style>
